module.exports = __webpack_public_path__ + "static/media/1.4 Wartung Servatius Staub klein.4afd4256.jpg";